import { GetInitialEntryTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialEntryTabs/getInitialEntryTabsQuery.type';
import { getInitialEntryTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialEntryTabs/getInitialEntryTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialEntryTabsQueryOptions = (
  params: GetInitialEntryTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getInitialEntryTabsQueryOptions', params],
    queryFn: () => getInitialEntryTabsFunction(params),
  });
};
